import {useEffect, useState} from "react";
import api from "../api";
import {Col, Row, Spin, Typography} from "antd";
import CategoryItem from "./Fragments/CategoryItem";
import {Helmet} from "react-helmet-async";
import {useTranslation} from "react-i18next";
import ChatPromoBanner from "../Fragments/ChatPromoBanner";

const { Title, Paragraph } = Typography;

function Categories({analytics}){
    const [categories,setCategories] = useState([])
    const [loading,setLoading] = useState(true)
    const { t } = useTranslation();

    useEffect(()=> {
        analytics()
        api.API.get('/api/tags').then(data=>{
           setCategories(data)
            setLoading(false)
        })
    },[])

    return(
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '20px' }}>
            <Helmet>
                <title>{t('seo.categories_title')}</title>
                <meta name="description" content={t('seo.categories_desc')} />
                <meta property="og:title" content={t('seo.categories_title')} />
                <meta property="og:description" content={t('seo.categories_desc')} />
            </Helmet>


            <div style={{ textAlign: 'center', marginBottom: 40 }}>
                <Title level={2}>{t('header.grouped_questions')}</Title>
                <Paragraph type="secondary">
                    {t('categories.description')}
                </Paragraph>
            </div>

            <Spin spinning={loading} size="large">
                <Row gutter={[16, 16]}>
                    {categories.map(i => (
                        <Col lg={6} md={8} sm={12} xs={12} key={i.id}>
                            <CategoryItem id={i.id} name={i.name} count={i.questions_count}/>
                        </Col>
                    ))}
                </Row>
            </Spin>
        </div>
    )
}
export default Categories;
